import Router from '../router/modules'

const filterRouters = filterRoutes(Router)

function filterRoutes(routes) {
  return routes.filter(route => {
    const { meta = {} } = route
    const { hidden } = meta

    if (!hidden) {
      if (route.children) {
        route.children = filterRoutes(route.children)
      }

      route.label = meta.label
      route.accessId = meta.accessId

      return true
    } else {
      return false
    }
  })
}

export default filterRouters
